import { ArrowRight } from 'lucide-react';

import { type MessageDestinationLink } from '@apps/web/components/phoebe_chat_view/transcript_types';

export function AssistantResponseDestinationLinks({
    destinationLinks,
}: {
    readonly destinationLinks?: Array<MessageDestinationLink>;
}) {
    if (!destinationLinks || destinationLinks.length === 0) {
        return null;
    }

    return (
        <div className="mt-2 flex flex-wrap gap-2">
            {destinationLinks.map((link) => (
                <a
                    key={`${link.label}-${link.url}`}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:text-primary/80 bg-background inline-flex h-7 items-center gap-1.5 rounded-md border border-[#d4d4d4] px-2 text-xs font-medium underline-offset-2 hover:bg-[#fafafa]"
                >
                    {link.label}
                    <ArrowRight className="size-3" />
                </a>
            ))}
        </div>
    );
}
